import {mutationTypes} from '@/core/constants'

export default {
    [mutationTypes.REAVALIACAO.SET_FILTROS_BUSCA_TODAS_REAVALIACOES](state, filtros) {
        state.todasReavaliacoes.filtros = filtros
    },
    [mutationTypes.REAVALIACAO.SET_PAGINACAO_BUSCA_TODAS_REAVALIACOES](state, paginacao) {
        state.todasReavaliacoes.paginacao = paginacao
    },

    [mutationTypes.REAVALIACAO.RESETA_PAGE](state) {
        state.todasReavaliacoes.paginacao.page = 1
    }

}
